/**
 * The side panel's field box, shared by its dropdown trigger
 * (`common/PropertyDropdown`) and its number field (`numericalInputStyles` on
 * `sidepanel/PropertyNumericalInput`), so the two can never drift apart again
 * (docs/design-system.md § "Panel Fields (Element Settings)", PLAT-12137).
 *
 * A plain string, not a `css` block, because `PropertyNumericalInput` takes its
 * overrides as a string.
 *
 * The neutral resting → hover → focus escalation of the Form Fields pattern on a
 * filled, compact box: `--panel-field-h`, `--input-background`, `--radius-input`,
 * `--text-xs`. Focus is gray, never gold or green.
 */
export const PANEL_FIELD_CSS = `
  box-sizing: border-box;
  width: 100%;
  height: var(--panel-field-h);
  margin: 0;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-input);
  background: var(--input-background);
  color: var(--foreground);
  font-family: var(--font-primary);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-normal);
  line-height: var(--leading-text-xs);
  outline: none;
  transition:
    border-color var(--transition-fast),
    box-shadow var(--transition-fast);

  &:hover:not(:disabled) {
    border-color: var(--text-muted);
  }

  &:focus-visible {
    border-color: var(--focus-border);
    box-shadow: 0 0 0 1px var(--focus-ring);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
